import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const GeneralInfo = (props) => {
  const { data, column } = props;

  return (
    <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
      {column === "code" && <div>{data.code}</div>}
      {column === "value" && <div>{data.value}</div>}
      {column === "description" && <div>{data.description}</div>}
    </DivBackgroundOpacity>
  );
};

GeneralInfo.propTypes = {
  data: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.bool,
  }),
  column: PropTypes.string,
};

GeneralInfo.defaultProps = {
  data: {},
  column: null,
};

export default withTranslation()(GeneralInfo);
